import axios from 'axios'
import { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import { useGlobalContent } from '../context/helpersProvider'
import { roleUser } from '../interfaces/roleUser'
import logo from '../media/Balanz_white_logo.svg'
import validate from '../utils/validateNewUser'
import { inputInterface } from '../utils/validateNewUser'
import { MultiSelect } from "primereact/multiselect";
import expiredToken from '../utils/headerAuth'

export const NewUser = () => {
  const history = useNavigate()

  const [errors, setErrors] = useState<inputInterface>({
    name: '',
    lastName: '',
    email: '',
    company: '',
    roleCompany: '',
    location: '',
  })

  const [valid, SetValid] = useState('')

  const [input, setInput] = useState<inputInterface>({
    name: '',
    lastName: '',
    email: '',
    company: '',
    roleCompany: '',
    location: '',
  })

  const [listLocation, setListLocation] = useState([
    "Argentina",
    "Brazil",
    "Chile",
    "Denmark",
    "France",
    "Germany",
    "Italy",
    "Panama",
    "Peru",
    "Switzerland",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Other"
  ]);

  const { setShowLoading, setShowToast } = useGlobalContent()

  function handleMultiSelectChange(value: string[]) {
    if (value.length > 0) {
      const lastSelected = value[value.length - 1]; // Toma la última selección
      setSelectedLocations([lastSelected]); // Actualiza el estado visual del MultiSelect
      setInput((prev) => ({
        ...prev,
        location: lastSelected, // Almacena el último seleccionado como string
      }));
    } else {
      // Si no hay selecciones (se elimina todo), limpia el estado
      setSelectedLocations([]);
      setInput((prev) => ({
        ...prev,
        location: '', // Limpia el campo de ubicación
      }));
    }
  }

  type Role = {
    id: string;
    name: string;
  };

  const [selecteRole, setSelectedRole] = useState<Role[]>([]);

  function handleRoleCompanyChange(value: Role[]) {
    if (value.length > 0) {
      const lastSelected = value[value.length - 1]; // Toma la última selección

      setSelectedRole([lastSelected]); // Actualiza el estado visual del MultiSelect
      setInput((prev) => ({
        ...prev,
        roleCompany: lastSelected.id, // Almacena el último seleccionado como string
      }));
    } else {
      // Si no hay selecciones (se elimina todo), limpia el estado
      setSelectedRole([]);
      setInput((prev) => ({
        ...prev,
        roleCompany: '', // Limpia el campo de ubicación
      }));
    }
  }





  function handleInputChange(e: any) {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    })
  }



  function handleErrors(e: any) {
  }

  interface rolesUserInterface extends Array<roleUser> { }

  const [roles, SetRoles] = useState<rolesUserInterface>()
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]); // Define el tipo explícito como string[]


  useEffect(() => {
    if (!roles) {
      setShowLoading('true')
      axios
        .get('/user/roleCompany/1')
        .then((json) => json.data)
        .then((datos) => {
          SetRoles(datos.data)
        })
        .catch((err) => {
          expiredToken(history, err, setShowToast);
      });
      setShowLoading('false')
    }
  })

  const sendData = (e: any) => {
    e.preventDefault()
    const err = validate(input)
    if (Object.keys(err).length > 0) {
      // hay error
      setErrors({
        name: err?.name,
        lastName: err?.lastName,
        email: err?.email,
        company: err?.company,
        roleCompany: err?.roleCompany,
        location: err?.location,
      })
    } else {
      // no hay error
      setErrors({
        name: '',
        lastName: '',
        email: '',
        company: '',
        roleCompany: '',
        location: '',
      })
    }
    if (err.company || err.email || err.lastName || err.name || err.position || err.location || err.roleCompany) {
      return
    } else {
      setShowLoading('true')
      axios
        .get(`/user/validate/${input.email}`)
        .then((json) => json.data)
        .then((datos) => {
          setShowLoading('false')
          if (datos.data === 1) {
            setShowLoading('true')
            axios
              .post('/user', {
                first_name: input.name?.trim(),
                last_name: input.lastName?.trim(),
                email: input.email?.trim(),
                company: input.company?.trim(),
                role_access_user: 1,
                role_company: input.roleCompany,
                description: '',
                location: input.location,
              })
              .then(() => {
                setShowLoading('false')
                history('/verify_info', { state: input.email })
              })
              .catch((error) => {
                setShowLoading('false')
                setShowToast({ open: 'true', type: 'error', message: 'Error' })
                expiredToken(history, error, setShowToast);
              })
          } else if (datos.data === 0) {
            setShowToast({ open: 'true', type: 'error', message: datos.message })
            SetValid(datos.message)
          } else if (datos.data === 2) {
            //history({pathname: '/verify', state: input.email})
          }
        })
        .catch((error) => {
          setShowLoading('false')
          setShowToast({ open: 'true', type: 'error', message: 'Error' })
          expiredToken(history, error, setShowToast);
      });
    }
  }

  const Click = (e: any) => {
    e.preventDefault()
    history('/')
  }
  return (
    <div className='columns w-row container-log'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img
          src={logo}
          loading='lazy'
          alt='Balanz logo'
          width='600'
          sizes='(max-width: 479px) 63vw, (max-width: 767px) 40vw, (max-width: 991px) 35vw, 23vw'
          className='loginlogo'
        />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          <button onClick={Click} className='back-button w-inline-block' />
          <form id='wf-form-company' name='wf-form-company' data-name='company' method='get'>
            <h3 className='h2-titles'>New User</h3>
            <div className='duo-form'>
              <div>
                <label htmlFor='Your-name' className='field-label'>
                  Name
                </label>
                <input
                  type='text'
                  className='text-field normal w-input'
                  autoFocus={true}
                  maxLength={256}
                  name='name'
                  placeholder='Name'
                  onChange={handleInputChange}
                  onBlur={handleErrors}
                  value={input.name}
                  autoComplete="off"
                />
                {errors.name && <p className='alert'>{errors.name}</p>}
              </div>
              <div>
                <label htmlFor='Lastname' className='field-label'>
                  Last Name
                </label>
                <input
                  type='text'
                  className='text-field normal w-input'
                  maxLength={256}
                  name='lastName'
                  data-name='Lastname'
                  placeholder='Last Name'
                  id='Lastname'
                  onBlur={handleErrors}
                  onChange={handleInputChange}
                  value={input.lastName}
                  autoComplete="off"
                />
                {errors.lastName && <p className='alert'>{errors.lastName}</p>}
              </div>
            </div>
            <div>
              <label htmlFor='Email' className='field-label'>
                Your Corporate E-mail
              </label>
              <input
                type='email'
                className='text-field email w-input'
                maxLength={256}
                name='email'
                data-name='Email'
                placeholder='Your Corporate E-mail'
                id='Email'
                onBlur={handleErrors}
                onChange={handleInputChange}
                value={input.email}
                autoComplete="off"
              />
              {errors.email && <p className='alert'>{errors.email}</p>}
            </div>
            <div>
              <label htmlFor='Company' className='field-label'>
                Company
              </label>
              <input
                type='text'
                className='text-field company w-input'
                maxLength={256}
                name='company'
                data-name='Email 2'
                placeholder='Your Company'
                id='Company'
                onBlur={handleErrors}
                onChange={handleInputChange}
                value={input.company}
                autoComplete="off"
              />
              {errors.company && <p className='alert'>{errors.company}</p>}
            </div>
            <div>
              <label htmlFor='Location' className='field-label'>
                Location
              </label>
              <MultiSelect
                value={selectedLocations}
                options={listLocation.map((item) => ({ label: item, value: item }))}
                onChange={(e: any) => handleMultiSelectChange(e.value)}
                placeholder="Select your location"
                className="select-field location w-select-prime"
                style={{
                  background: '#e7e9fa',
                  border: 'none',
                  color: '#333',
                  fontWeight: 600,
                  fontSize: '15px'
                }}
                appendTo={document.body}
                panelHeaderTemplate={() => <></>}
              />
              {/* <select
                className='select-field location w-select'
                name='location'
                id="Location"
                onChange={handleInputChange}
                value={input.location}
                data-name=''
              >
                <option hidden value=''>Select your location</option>
                {
                  listLocation.map((item) => (
                    <option key={item} value={item}>{item}</option>
                  ))
                }
              </select> */}
              {errors.location && <p className='alert'>{errors.location}</p>}
            </div>
            <div>
              <label htmlFor='roleCompany' className='field-label'>
                Role
              </label>
              <MultiSelect
                options={roles}
                optionLabel="name"
                style={{
                  background: '#e7e9fa',
                  border: 'none',
                  color: '#333',
                  fontWeight: 600,
                  fontSize: '15px'
                }}
                onChange={(e: any) => handleRoleCompanyChange(e.value)}
                placeholder="Select your company position"
                className="select-field w-select-prime"
                value={selecteRole}
                maxSelectedLabels={1}
                appendTo={document.body}
                panelHeaderTemplate={() => <></>}
              />

              {/* <select
                onChange={handleInputChange}
                name='roleCompany'
                data-name=''
                id="roleCompany"
                className='select-field w-select'
              >
                <option hidden>Select your company position</option>
                {roles?.map((e) => (
                  <option value={e.id} key={e.id}>
                    {e.name}
                  </option>
                ))}
              </select> */}
              {errors.roleCompany && <p className='alert'>{errors.roleCompany}</p>}
            </div>
            {/* <p className='alert'>{valid}</p> */}
            <span onClick={sendData} className='button continue w-button'>
              Continue
            </span>
          </form>
        </div>
      </div>
    </div>
  )
}
